// Styles
import CompanyModelViewContainer from "./CompanyModelView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useBQMQ } from "context/BQMQ.context";

type Props = {};

export default function CompanyModelView({}: Props) {
    const location = useLocation();
    const { companies } = useBQMQ();

    const companyId = useMemo(() => {
        return new URLSearchParams(location.search).get("company_id");
    }, [location.search]);

    const company = useMemo(() => {
        if (!companyId) return null;
        return (
            companies.find(
                (c: BQMQDropdownCompany) => String(c.value) === companyId
            ) ?? null
        );
    }, [companyId, companies]);

    const redshiftId = company?.redshift_company_id ?? null;

    const filterString =
        redshiftId != null
            ? `HistoricSnapshot/company_id eq ${redshiftId}`
            : undefined;

    return (
        <CompanyModelViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="d42b52c6-0fb0-4233-9a18-e55a58b1daed"
                    workspaceId="ba0ccfe6-4d32-44b6-aca5-e2ac72312904"
                    filterString={filterString}
                />
            </div>
        </CompanyModelViewContainer>
    );
}
